import {
  TABBED_TOOLBAR_SET_TABS_ENABLED,
} from '../TabbedToolbarConstants';

export const DEFAULT_STATE = true;

export default (state = DEFAULT_STATE, action) => {
  if (action.type === TABBED_TOOLBAR_SET_TABS_ENABLED) {
    return action.enabled;
  }
  return state;
};



// WEBPACK FOOTER //
// ./src-react/TabbedToolbar/reducer/tabsEnabled.js